import React, { useState, useImperativeHandle, forwardRef } from 'react';
import Button from '@material-ui/core/Button';
import Api from '../../../../__helpers/api'
import { useHistory } from 'react-router-dom'
import { useAuthDataContext } from '../../../../__providers/AuthProvider';

//images
import multiTestsImg from '../../../../assets/images/test/guide/2_1.png'
import testsImg from '../../../../assets/images/test/guide/2_2.png'
import lastImg from '../../../../assets/images/profile/guide/tests/1_6.png'

import rightArrowIcon from '../../../../assets/images/profile/right-arrow.png'
import leftArrowIcon from '../../../../assets/images/profile/left-arrow-blue.png'


function Major(props, ref) {
    const auth = useAuthDataContext();
    const history = useHistory()

    const [major, setMajor] = useState({
        blur: false,
        popup: false,
        currentStep: 1,
        href: '',
    })

    async function handleSlide() {
        if (major.currentStep == 3) {
            await Api.post('student/hide-test-tutor2')
                .then(() => {
                    auth.refresh()
                })

            handleClose()
        }
        setMajor(major => ({
            ...major,
            currentStep: major.currentStep == 3 ? 3 : major.currentStep + 1
        }))

        let guideSlides
        if (document.getElementsByClassName('guide-slider')) {
            guideSlides = document.getElementsByClassName('guide-slider')[0].children
        }

        if (major.currentStep < 3) {
            for (let i = 0; i < guideSlides.length; i++) {
                guideSlides[i].classList.remove('active')
                if (guideSlides[i].getAttribute('data-id') == major.currentStep + 1) {
                    guideSlides[i].classList.add('active')
                }
            }
        }
    }

    const handleBack = () => {
        setMajor(major => ({
            ...major,
            currentStep: major.currentStep == 1 ? 1 : major.currentStep - 1
        }))

        let guideSlides = document.getElementsByClassName('guide-slider')[0].children

        if (major.currentStep <= 3) {
            for (let i = 0; i < guideSlides.length; i++) {
                guideSlides[i].classList.remove('active')
                if (guideSlides[i].getAttribute('data-id') == major.currentStep - 1) {
                    guideSlides[i].classList.add('active')
                }
            }
        }
    }

    useImperativeHandle(ref, () => ({
        open: href => {
            handleOpen(href)
        },
        close: () => {
            handleClose()
        }
    }))

    const handleOpen = href => {
        setMajor(major => ({
            ...major,
            blur: true,
            href: href,
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                popup: true
            }))
        }, 50);
    }

    const handleClose = () => {
        setMajor(major => ({
            ...major,
            popup: false
        }))
        setTimeout(() => {
            setMajor(major => ({
                ...major,
                blur: false,
                currentStep: 1
            }))
            document.getElementsByClassName('guide-slider')[0].children[0].classList.add('active')
            history.push(major.href)
            props.repeat()

        }, 100);
    }

    return (
        <div id="overlay" className={major.blur ? 'visible' : ''}>
            <div className={`box guide test-guide ${major.popup ? 'show' : ''}`}>
                <div className="guide-slider-wrapper">
                    <ul className={`guide-slider no-arrows slide-${major.currentStep}`}>
                        <li data-id="1" className="active">
                            <img src={multiTestsImg} alt="road" />
                        </li>
                        <li data-id="2">
                            <img src={testsImg} alt="video" />
                        </li>
                        <li data-id="3">
                            <img src={lastImg} alt="video" />
                        </li>
                    </ul>
                </div>

                <ul className="guide-content">
                    {major.currentStep == 1 ?
                        <li>
                            <h3>
                                Интелигентно съставяне на тест
                            </h3>
                            <p>
                                Авто Обучение съставя тестовете интелигентно в зависимост от това на какъв етап сте и какво е нивото на Вашите знания в момента.
                            </p>
                        </li>
                        :
                        major.currentStep == 2 ?
                            <li>
                                <h3>
                                    Тест от сгрешени въпроси
                                </h3>
                                <p>
                                    Когато вече сте решили всички въпроси от Тема 1, Авто Обучение ще Ви състави тестове предимно от въпроси, които сте сгрешили. Така лесно ще преминете отново през въпросите, които Ви затрудняват.
                                </p>
                            </li>
                            :
                            major.currentStep == 3 ?
                                <li>
                                    <h3>
                                        Продължете с решаването
                                    </h3>
                                    <p>
                                        Моля продължете с решаването на изпитни въпроси от Тема 1. Препоръчваме Ви да преминете към следващата тема, когато имате отличен резултат на тази.
                                    </p>
                                </li>
                                :
                                ''
                    }
                </ul>

                <div className="buttons">
                    <div className="row">
                        {major.currentStep > 1 ?
                            <Button className="back-btn" onClick={handleBack}>
                                <img src={leftArrowIcon} alt="next" />
                            </Button>
                            :
                            ''
                        }
                        <Button data-id={major.currentStep} onClick={handleSlide}>
                            {major.currentStep < 3 ?
                                <>
                                    Напред
                            <img src={rightArrowIcon} alt="next" />
                                </>
                                :
                                'Разбрах'
                            }
                        </Button>
                    </div>

                    <ul className="indicator">
                        <li className={major.currentStep == 1 ? 'active' : ''}>

                        </li>
                        <li className={major.currentStep == 2 ? 'active' : ''}>

                        </li>
                        <li className={major.currentStep == 3 ? 'active' : ''}>

                        </li>
                    </ul>
                </div>
            </div>
        </div >
    )
}

export default forwardRef(Major);